var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 34,
    viewBox: "0 0 129 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2052_27660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9833 25.8515C57.9098 25.8515 53.7354 21.3787 53.7354 15.0221V1.03906H60.2185V15.211C60.2185 16.5763 60.7104 19.8249 64.9833 19.8249C67.832 19.8249 69.8943 17.8949 69.8943 15.211V1.03906H76.3778V15.0221C76.3778 21.1909 71.859 25.8515 64.9833 25.8515Z",
    fill: "#596871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4353 25.8524C84.0012 25.8524 79.2373 22.6034 78.4517 17.377H85.0328C85.9169 19.4493 88.5201 20.2025 90.4353 20.2025C93.039 20.2025 95.0036 19.4493 95.0036 18.0367C95.0036 16.6716 94.1196 16.1064 89.6992 15.4472C85.1807 14.7877 79.1392 13.6112 79.1392 8.19593C79.1392 4.38264 82.6261 0.427734 89.9447 0.427734C95.7402 0.427734 100.063 3.44103 100.897 8.00814H94.1686C93.7756 6.87807 92.3514 5.98375 89.9447 5.98375C86.9485 5.98375 85.7208 7.01904 85.7208 7.91382C85.7208 9.18525 87.5874 9.60881 90.7303 10.0796C97.0173 11.0683 101.536 12.3868 101.536 17.66C101.536 22.4627 96.9193 25.8524 90.4353 25.8524Z",
    fill: "#596871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.137 5.88918C119.231 5.88918 121.687 7.67853 122.472 10.5035H109.899C110.832 7.67853 113.19 5.88918 116.137 5.88918ZM121.49 17.5657C120.41 19.4959 118.298 20.3903 116.137 20.3903C113.092 20.3903 110.636 18.5548 109.801 15.5883H128.907C129.84 5.98376 123.651 0.427734 116.185 0.427734C109.064 0.427734 103.219 6.17176 103.219 13.187C103.219 20.2025 109.064 25.8524 116.185 25.8524C121.328 25.8524 125.253 23.6154 127.319 20.0958L121.49 17.5657Z",
    fill: "#596871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4092 25.8015H11.0833V17.366L0 1.03906H7.08752L14.2221 11.1419L21.405 1.03906H28.4922L17.4092 17.366V25.8015Z",
    fill: "#596871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0559 13.2341C45.0559 9.04409 42.2569 6.1247 38.8186 6.1247C35.3804 6.1247 32.5806 9.04409 32.5806 13.2341C32.5806 17.3308 35.3804 20.1552 38.8186 20.1552C42.2569 20.1552 45.0559 17.3308 45.0559 13.2341ZM51.5885 13.187C51.5885 20.4378 45.842 25.8524 38.8186 25.8524C31.7951 25.8524 26.0977 20.4378 26.0977 13.187C26.0977 5.93623 31.7951 0.427734 38.8186 0.427734C45.842 0.427734 51.5885 5.93623 51.5885 13.187Z",
    fill: "#FCAF17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.576 33.2861C51.576 30.1599 49.0553 28.3301 45.946 28.3301H31.7418C28.6318 28.3301 26.1113 30.1599 26.1113 33.2861H51.576Z",
    fill: "#FCAF17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2052_27660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 33.0733,
    fill: "white",
    transform: "translate(0 0.427734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouseLogo);
export default __webpack_public_path__ + "static/media/youse-logo.e490114f.svg";
export { ForwardRef as ReactComponent };